// extracted by mini-css-extract-plugin
export var quantityInput = "_lw-0";